import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react'

export function SortableHeader({ label, column }: { label: string; column: any }) {
  return (
    <div
      className="flex items-center gap-1 cursor-pointer select-none"
      onClick={() => column.toggleSorting()}
    >
      <span>{label}</span>
      {column.getIsSorted() === 'asc' ? (
        <ArrowUp className="h-4 w-4" />
      ) : column.getIsSorted() === 'desc' ? (
        <ArrowDown className="h-4 w-4" />
      ) : (
        <ChevronsUpDown className="h-4 w-4 opacity-50" />
      )}
    </div>
  )
}
